import { render, staticRenderFns } from "./SucursalInventarioResumen.vue?vue&type=template&id=7cca8c66&scoped=true&"
import script from "./SucursalInventarioResumen.vue?vue&type=script&lang=js&"
export * from "./SucursalInventarioResumen.vue?vue&type=script&lang=js&"
import style0 from "./SucursalInventarioResumen.vue?vue&type=style&index=0&id=7cca8c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca8c66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VRow,VSkeletonLoader})
